import * as React from 'react';
import throttle from 'lodash-es/throttle';

export function useThrottle(func: (...args: any) => any, throttleDelay: number) {
    return React.useMemo(
        () =>
            throttle(func, throttleDelay, {
                leading: true,
                trailing: false,
            }),
        [func, throttleDelay]
    );
}
